import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'cpf', 'cpflabel'
  ]

  fill() {
    if (this.cpfTarget.value.length < 14 || (this.cpfTarget.value.length == 14 && ! cpfValidation(this.cpfTarget.value))) {
      this.cpfTarget.setCustomValidity("CPF inválido")
      this.cpfTarget.classList.add('reveal-validation')
    }
    if (this.cpfTarget.value.length == 0 || (this.cpfTarget.value.length == 14 && cpfValidation(this.cpfTarget.value))) {
      this.cpfTarget.setCustomValidity("");
      this.cpfTarget.classList.remove('reveal-validation')
      if (this.hasCpflabelTarget) {
        this.cpflabelTarget.innerHTML = 'CPF'
      }
    }

    if ((this.hasCpflabelTarget) && this.cpfTarget.value.length == 14 && !cpfValidation(this.cpfTarget.value)) {
      this.cpflabelTarget.innerHTML = 'CPF - <small style="color:red">numeração inválida</small>'
    }
  }
}

function cpfValidation(cpf) {
  var add = 0;
  var i;
  cpf = cpf.replace(/[^\d]+/g,'');
  if(cpf == '') return false;
  if (cpf.length != 11)
      return false;
  for (i=0; i < 9; i ++)
    add += parseInt(cpf.charAt(i)) * (10 - i);
    var rev;
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
      return false;
  add = 0;
  for (i = 0; i < 10; i ++)
    add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(10)))
    return false;
  return true;
}



